import React, { FunctionComponent } from 'react';
import { PersonShowMainProps, PersonShowMainState } from './types';
import { PersonShowMainAlert } from '../../molecules/personShowMainAlert';
import { PersonShowMainAlertScout } from '../../molecules/personShowMainAlertScout';
import { PersonShowMainTop } from '../../molecules/personShowMainTop';
import { PersonShowMainMiddle } from '../../molecules/personShowMainMiddle';
import { PersonShowMainBottom } from '../../molecules/personShowMainBottom';
import { PersonShowMainSpContacts } from '../../molecules/personShowMainSpContacts';
import { ScoutPersonShow } from '../../molecules/scoutPersonShow';
import { RecommendModal } from '../../molecules/recommendModal';
import { ScoutModal } from '../../molecules/scoutModal';
import { Button } from '../../atoms/button';
import { Loading } from '../../atoms/loading';
import { RecommendMinimumModal } from '../../molecules/recommendMinimumModal';

type Props = PersonShowMainProps & {
  state: PersonShowMainState;
  isRecommendModalOpen: boolean;
  isRecommendMinimumModalOpen: boolean;
  onClickLike: () => void;
  handleModalOpen: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleModalOff: () => void;
  handleModalClose: () => void;
  handleRecommendModalClose: () => void;
  handleRecommendMinimumModalClose: () => void;
  insertNotification: (insertMessage: string) => void;
  onOpenModal: (target: string, title: string) => void;
  handleChangeClickTarget: (value: number) => void;
  fetchSidebarDetails: () => void;
  sensRequestResume: (type: string) => void;
  personIsScouted: () => void;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  const fetchDisplaySectionTop = () => {
    return (
      props.isShow ||
      props.introduction ||
      (Array.isArray(props.educationalHistories) && props.educationalHistories.length > 0) ||
      (!props.isOneYearPassed && Array.isArray(props.careerHistories) && props.careerHistories.length > 0) ||
      (props.isStudent && props.activity) ||
      props.slogan ||
      (Array.isArray(props.interests) && props.interests.length > 0) ||
      (Array.isArray(props.skills) && props.skills.length > 0) ||
      (Array.isArray(props.favoriteBrands) && props.favoriteBrands.length > 0)
    );
  };
  const shouldDisplayMiddleSection = () => {
    if (props.fromPage === 'companyPeople') return false;
    return props.isShow || props.motivation !== null || props.preferredLocations.length || props.preferredOccupations.length || props.preferenceConditions.length;
  };

  return (
    <section className="person__show__main">

      {/* OFFLINEバナー非表示 */}
      {/* {props.isPc && props.showOffline011Banner && props.offline011 && (
        <a href="/lp/offline/tokyo" className="offline gtm-offline-view-count" data-event-name="offline on screen" data-event="click" data-category="person_profile" data-value="offline011_banner">
          <img src={props.offline011} alt="OFFLINEイベントバナー" />
        </a>
      )} */}

      {props.fromPage === 'companyShow' && props.memo !== undefined && props.handleMemoChange && (
        <div className="person__show__details__tablet">
          <div className="person__show__details__tablet__section">
            <p className="person__show__details__tablet__section--title">求職者メモ</p>
            <textarea
              className="person__show__details__memo"
              placeholder="求職者のメモを残せます"
              value={props.memo}
              onChange={props.handleMemoChange}
            />
          </div>
        </div>
      )}
      {props.unCompletedProfile && props.isShow && props.isPc && (
        <PersonShowMainAlert personId={props.personId} />
      )}
      {props.isPc && !props.isShow && props.fromPage === 'scout' && (
        <PersonShowMainAlertScout personId={props.personId} isPc={props.isPc} />
      )}
      {!fetchDisplaySectionTop() && !shouldDisplayMiddleSection() && (
        <>
          <h2 className="mainTitle">プロフィール情報</h2>
          <p className="profile__blank">プロフィール情報は未記入です</p>
        </>
      )}
      {fetchDisplaySectionTop() && (
        <PersonShowMainTop
          mainTitle="プロフィール情報"
          isOneYearPassed={props.isOneYearPassed}
          penIconImg={props.penIconImg}
          introduction={props.introduction}
          educationalHistories={props.educationalHistories}
          careerHistories={props.careerHistories}
          activity={props.activity}
          slogan={props.slogan}
          interests={props.interests}
          skills={props.skills}
          favoriteBrands={props.favoriteBrands}
          handleOpenModal={props.onOpenModal}
          onChangeClickTarget={props.handleChangeClickTarget}
          isShow={props.isShow}
          isStudent={props.isStudent}
          careerEmploymentTypes={props.careerEmploymentTypes}
        />
      )}
      {fetchDisplaySectionTop() && shouldDisplayMiddleSection() && <hr className="person__show__main--devide" />}
      {shouldDisplayMiddleSection() && (
        <PersonShowMainMiddle
          penIconImg={props.penIconImg}
          mainTitle="希望条件"
          motivation={props.motivation}
          preferredLocations={props.preferredLocations}
          preferredOccupations={props.preferredOccupations}
          preferenceConditions={props.preferenceConditions}
          handleOpenModal={props.onOpenModal}
          isShow={props.isShow}
        />
      )}
      {!props.isHidden && (
        <PersonShowMainBottom
          isOneYearPassed={props.isOneYearPassed}
          penIconImg={props.penIconImg}
          mainTitle={props.isStudent ? '履歴書' : '履歴書・職務経歴書'}
          personId={props.personId}
          handleOpenModal={props.onOpenModal}
          isShow={props.isShow}
          resume={props.resume}
          job_resume={props.job_resume}
          resumeUpdatedAt={props.resumeUpdatedAt}
          jobResumeUpdatedAt={props.jobResumeUpdatedAt}
          isStudent={props.isStudent}
          isNotRequestedResume={props.isNotRequestedResume}
          isNotRequestedJobResume={props.isNotRequestedJobResume}
          fromPage={props.fromPage}
          handleRequestResume={props.sensRequestResume}
        />
      )}
      {!props.isPc && props.fromPage !== 'scout' && props.fromPage !== 'companyPeople' && (
        <PersonShowMainSpContacts
          isPc={props.isPc}
          isShow={props.isShow}
          mail={props.mail}
          tel={props.tel}
          twitter={props.twitter}
          instagram={props.instagram}
          penIconImg={props.penIconImg}
          personId={props.personId}
          handleOpenModal={props.onOpenModal}
          handleFetchSidebarDetails={props.fetchSidebarDetails}
        />
      )}
      {props.fromPage === 'companyShow' && (
        <div className="person__show__main__bottomBtns">
          <div className="person__show__main__bottomBtns--dates">
            {props.state.recentlyActiveDate ? (
              <p>直近のアクティブ日:{props.state.recentlyActiveDate}</p>
            ) : (
              <p>直近のログイン日:{props.state.recentlySignedIn}</p>
            )}
            <p>直近のプロフィール更新日:{props.state.recentlyUpdated}</p>
          </div>
          <a href={`/management/messages/${props.messageBoxId}`} target="_blank" className="message">メッセージで連絡</a>
        </div>
      )}
      {props.fromPage === 'scout' && (
        <div className={`person__show__main__bottomBtns ${props.isAlreadyConnected ? 'alreadyConnected' : ''}`}>
          <ScoutPersonShow personId={props.personId} />
          {props.isAlreadyConnected ? (
            <a href={`/management/messages/${props.messageBoxId}`} target="_blank" className="to-message-button">メッセージで連絡</a>
          ) : (
            <div className="btns">
              {props.state.liked1monthAgo ? (
                <p className="button scouts-person-link-scout-liked">気になる済み</p>
              ) : (
                <Button className="button scouts-person-link-scout-like" onClicked={props.onClickLike} personId={props.personId} defaultValue="気になる" />
              )}
              {props.state.scouted ? (
                <Button className="button scouts-person-link-scouted js-acquisition-person-id" onClicked={props.handleModalOpen} personId={props.personId} personSrc={props.state.icon} defaultValue="スカウト済み" />
              ) : (
                <Button className="button scouts-person-link-scout js-acquisition-person-id" onClicked={props.handleModalOpen} personId={props.personId} personSrc={props.state.icon} defaultValue="スカウト" />
              )}
            </div>
          )}
        </div>
      )}
      <RecommendModal isModalOpen={props.isRecommendModalOpen} onClose={props.handleRecommendModalClose} />
      <RecommendMinimumModal isModalOpen={props.isRecommendMinimumModalOpen} onClose={props.handleRecommendMinimumModalClose} />
      {props.state.loading && (
        <div className="applicants-loading" style={props.state.loadingStyle}>
          <Loading />
        </div>
      )}
      {props.state.isModalOpen && (
        <ScoutModal
          isAllowedToScout={props.isAllowedToScout}
          isMinimum={props.isMinimum}
          icon={props.state.personSrc}
          personId={props.personId}
          isBookmarked={props.state.isBookmarked}
          isAlreadyConnected={props.isAlreadyConnected}
          messageBoxId={props.messageBoxId}
          personIsScouted={props.personIsScouted}
          handleModalClose={props.handleModalClose}
          insertNotification={props.insertNotification}
          style={props.state.modalStyle}
        />
      )}
    </section>
  );
};
